/* Second Story — theme interactions */
(function () {
  // Mobile drawer
  var toggle = document.querySelector('.nav-toggle');
  var drawer = document.querySelector('.mobile-drawer');
  var overlay = document.querySelector('.drawer-overlay');
  function closeDrawer(){ drawer&&drawer.classList.remove('open'); overlay&&overlay.classList.remove('open'); }
  if (toggle) toggle.addEventListener('click', function(){ drawer.classList.add('open'); overlay.classList.add('open'); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.querySelectorAll('.drawer-close').forEach(function(b){ b.addEventListener('click', closeDrawer); });

  // Announcement close
  document.querySelectorAll('.ann-close').forEach(function(b){
    b.addEventListener('click', function(){ b.closest('.announcement').style.display='none'; });
  });

  // Carousels
  document.querySelectorAll('[data-carousel]').forEach(function(car){
    var row = car.querySelector('.product-row');
    var prev = car.querySelector('.carousel-btn.prev');
    var next = car.querySelector('.carousel-btn.next');
    if(!row) return;
    function amount(){ var c=row.querySelector('.product-card'); return c? c.offsetWidth+24 : 300; }
    function update(){
      if(!prev||!next) return;
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    }
    prev && prev.addEventListener('click', function(){ row.scrollBy({left:-amount()*2,behavior:'smooth'}); });
    next && next.addEventListener('click', function(){ row.scrollBy({left:amount()*2,behavior:'smooth'}); });
    row.addEventListener('scroll', update); window.addEventListener('resize', update); update();
  });

  // Product gallery thumbs
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main = g.querySelector('.main-img img');
    g.querySelectorAll('.pd-thumbs .media').forEach(function(t){
      t.addEventListener('click', function(){
        var img = t.querySelector('img');
        if(main && img){ main.src = img.src; }
        g.querySelectorAll('.pd-thumbs .media').forEach(function(x){x.classList.remove('active');});
        t.classList.add('active');
      });
    });
  });

  // Quantity steppers (event delegation — survives theme-editor re-renders)
  document.addEventListener('click', function(e){
    var dec = e.target.closest('[data-minus]');
    var inc = e.target.closest('[data-plus]');
    if(!dec && !inc) return;
    var wrap = (dec||inc).closest('.qty');
    if(!wrap) return;
    var input = wrap.querySelector('input');
    if(!input) return;
    e.preventDefault();
    var min = parseInt(input.getAttribute('min'),10); if(isNaN(min)){ min = 1; }
    var val = parseInt(input.value,10)||min;
    input.value = inc ? val+1 : Math.max(min, val-1);
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  // Filter toggle (mobile)
  var ft = document.querySelector('.filter-toggle');
  if(ft) ft.addEventListener('click', function(){
    document.querySelector('.filters').classList.toggle('open');
  });

  // Wishlist toggle (visual only, delegated)
  document.addEventListener('click', function(e){
    var w = e.target.closest('.wishlist');
    if(!w) return;
    e.preventDefault();
    w.classList.toggle('active');
  });
})();

/* Second Story — new section interactions */
(function () {
  // Countdown timers
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var expired = el.getAttribute('data-expired') || 'This offer has ended.';
    var nums = el.querySelectorAll('[data-cd]');
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        var clock = el.querySelector('.cd-clock');
        if (clock) clock.innerHTML = '<div class="cd-expired">' + expired + '</div>';
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff % 86400000 / 3600000);
      var m = Math.floor(diff % 3600000 / 60000);
      var s = Math.floor(diff % 60000 / 1000);
      var v = { days: d, hours: h, minutes: m, seconds: s };
      nums.forEach(function (n) {
        var k = n.getAttribute('data-cd');
        n.textContent = (v[k] < 10 ? '0' : '') + v[k];
      });
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var open = item.classList.contains('open');
      var group = item.closest('[data-faq]');
      if (group && !group.hasAttribute('data-multi')) {
        group.querySelectorAll('.faq-item.open').forEach(function (x) { x.classList.remove('open'); });
      }
      item.classList.toggle('open', !open);
    });
  });
})();

/* Second Story — predictive (instant) search */
(function () {
  document.querySelectorAll('[data-predictive]').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('.predictive-results');
    if (!input || !box) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = data.resources && data.resources.results;
            var products = (res && res.products) || [];
            if (!products.length) {
              box.innerHTML = '<div class="ps-empty">No matches — press Enter to search everything</div>';
              box.hidden = false; return;
            }
            box.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">'
                      : (p.image ? '<img src="' + p.image + '" alt="">' : '<div class="ps-noimg"></div>');
              var price = p.price ? '<span class="ps-p">' + p.price + '</span>' : '';
              return '<a class="ps-item" href="' + p.url + '">' + img + '<span class="ps-t">' + p.title + '</span>' + price + '</a>';
            }).join('');
            box.hidden = false;
          })
          .catch(function () { box.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false; });
  });
})();

/* Second Story — collection filters auto-apply */
(function () {
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.querySelectorAll('input[type=checkbox]').forEach(function (cb) {
      cb.addEventListener('change', function () { form.submit(); });
    });
    var sort = form.querySelector('select[name=sort_by]');
    if (sort) sort.addEventListener('change', function () { form.submit(); });
  });
})();

/* Second Story — AJAX add to cart (stay on page) */
(function () {
  function toast(msg, link) {
    var t = document.createElement('div');
    t.className = 'ss-toast';
    t.innerHTML = '<span>' + msg + '</span>' + (link ? '<a href="' + link + '">View cart</a>' : '');
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 300); }, 3200);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    var action = form.getAttribute('action') || '';
    if (!(form.matches('#product-form') || action.indexOf('/cart/add') !== -1)) return;
    {
      // let the dynamic checkout (Buy it now) button work normally
      if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return;
      e.preventDefault();
      var btn = form.querySelector('button[name="add"], button[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.dataset.label = label; btn.innerHTML = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw res.d;
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; el.style.display = ''; });
          toast('Added to cart ✓', '/cart');
        })
        .catch(function (err) { toast(err && err.description ? err.description : 'Sorry, could not add to cart.'); })
        .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.label || label; } });
    }
  });
})();

/* Second Story — cart line quantity auto-update (AJAX, no checkout) */
(function () {
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('input[data-cart-qty]')) return;
    var key = inp.getAttribute('data-key');
    if (!key) return;
    var qty = parseInt(inp.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    inp.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  });
})();
